export const moduleRoutes = [
  {
    permission: "access.dashboard",
    path: "/dashboard",
    match: ["/dashboard"],
  },
  {
    permission: "access.performance",
    path: "/performance",
    match: ["/performance"],
  },
  {
    permission: "access.recordings",
    path: "/recordings",
    match: ["/recordings"],
  },
  {
    permission: "access.realtime",
    path: "/realtime",
    match: ["/realtime"],
  },
  {
    permission: "access.configurations",
    path: "/operations",
    match: ["/operations", "/operation"],
  },
  {
    permission: "access.users",
    path: "/users",
    match: ["/users"],
  },
  {
    permission: "access.event_registrations",
    path: "/eventos/inscricoes",
    match: ["/eventos/inscricoes", "/walt-inscricoes"],
    aliases: ["access.walt_registrations", "access.walt-inscricoes", "access.walt_inscricoes"],
  },
  {
    permission: "access.payment",
    path: "/payment",
    match: ["/payment"],
  },
  {
    permission: "access.documentation",
    path: "/documentation",
    match: ["/documentation"],
  },
];

export function hasModulePermission(permissions, module) {
  const acceptedPermissions = [module.permission, ...(module.aliases || [])];

  return acceptedPermissions.some((permission) => permissions.includes(permission));
}

export function getDefaultModulePath(permissions) {
  const firstAllowedModule = moduleRoutes.find((module) => hasModulePermission(permissions, module));

  return firstAllowedModule ? firstAllowedModule.path : "/login";
}

export function getModuleForPath(path) {
  return moduleRoutes.find((module) => module.match.some((route) => path.startsWith(route)));
}

export function canAccessPath(permissions, path) {
  const module = getModuleForPath(path);

  return !module || hasModulePermission(permissions, module);
}
